/**************************************************************************************************/
/*   File: /src/app/shared/models/geo.file.type.ts                                                */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 12th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The file type for geometric dat<a
 */
export class GeoFileType {
    /**
     * The id
     */
    id: number;
    /**
     * The translation key
     */
    key: string;
}